import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { delay, map, tap } from 'rxjs/operators';

import { initActions } from '../actions/init.actions';
import { userApiActions } from '../actions/user.actions';

@Injectable()
export class UserEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  logoutUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userApiActions.logoutSuccess),
      delay(1),
      map(() => initActions.appCleanup())
    )
  );

  tokenExpired$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userApiActions.tokenExpired),
      delay(1),
      tap(() => this.router.navigate(['/login'])),
      map(() => userApiActions.logoutSuccess())
    )
  );

  tokenDeleted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userApiActions.tokenDeleted),
      delay(1),
      tap(() =>
        this.router.navigate(['/logged-out'], {
          state: { reason: 'token-deleted' },
        })
      ),
      map(() => userApiActions.logoutSuccess())
    )
  );
}
